<template>
	<page-container
		class="container vacancies"
		:page="page"
		:class="{ 'no-heading-image': !page.headingImage && !page.embedCode, 'no-video': !page.embedCode }"
	>
		<video-embed v-if="page.embedCode" :embedcode="page.embedCode" />

		<client-only>
			<div id="hiring-assistant" data-show-button data-show-banner="false" data-open></div>
		</client-only>

		<main-content :title="(page.title || page.header) ?? 'Page not found'" :content="page.content">
			<div class="row">
				<div class="columns column12 align-left">
					<h1 v-if="!page.headingImage">{{ page.title || page.header }}</h1>
					<wysiwyg-content :content="page.content" />
				</div>
			</div>
		</main-content>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
	</page-container>
</template>

<script setup lang="ts">
const { page, fetchPage } = usePage();
const config = useRuntimeConfig();
let retryTimer: number | undefined;

await fetchPage();

const openHiringAssistant = (attempt = 0) => {
	const assistant = window.hiringAssistant;

	if (assistant) {
		if (!assistant.isInitialized?.() && assistant.loadOtherAsync) {
			assistant.loadOtherAsync(config.public.soigneId);
			if (attempt < 20) {
				retryTimer = window.setTimeout(() => {
					openHiringAssistant(attempt + 1);
				}, 250);
			}

			return;
		}

		assistant.showButton?.();

		if (!assistant.isOpen?.()) {
			assistant.open?.();
		}

		return;
	}

	if (attempt < 20) {
		retryTimer = window.setTimeout(() => {
			openHiringAssistant(attempt + 1);
		}, 250);
	}
};

onMounted(async () => {
	document.body.classList.add('ha-widget-open');
	await nextTick();
	openHiringAssistant();
});

onBeforeUnmount(() => {
	window.clearTimeout(retryTimer);
	window.hiringAssistant?.close?.();
	window.hiringAssistant?.hideButton?.();
	document.body.classList.remove('ha-widget-open');
});

useHead({
	bodyAttrs: {
		class: 'vacancies subpage',
	},
});
</script>
